import { API_BASE_URL } from '../constants/suggestions';

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.detail || `HTTP error! status: ${response.status}`);
  }
  return data;
};

export const loginAPI = (email, password) => {
  return fetch(`${API_BASE_URL}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  }).then(handleResponse);
};

export const registerAPI = (username, email, password, user_type, token) => { 
  return fetch(`${API_BASE_URL}/api/register`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({ username, email, password, user_type }), 
  }).then(handleResponse);
};

export const getProfileAPI = (token) => {
  return fetch(`${API_BASE_URL}/api/profile`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  }).then(handleResponse);
};